/* eslint-disable sonarjs/no-nested-template-literals */
import languages from '../../utils/languages';
import _ from 'lodash';
import { adminAPI, collectionAPI, mediaAPI } from 'services/admin';

export const getCollectionById = async (
  path,
  auth,
  setAuth,
  setNotify,
  setIsLoading
) => {
  return new Promise(resolve => {
    const session = auth;

    const data = {
      createdBy: {
        userId: session.getIdToken().payload.sub,
        name: session.getIdToken().payload.username,
      },
    };

    return collectionAPI
      .get(path, data)
      .then(resp => {
        resolve(resp);
      })
      .catch(error => {
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Erro ao buscar coleção.',
        });
        //console.log(error);
      });
  });
};

export const updateCollection = async (
  path,
  auth,
  setAuth,
  setNotify,
  values,
  setIsLoading,
  relatedContents,
  activeStep,
  getValues,
  videoToCollection,
  id,
  version,
  Collection,
  setCollection
) => {
  return new Promise(resolve => {
    setIsLoading(true);
    const session = auth;

    // Map to APU value
    if (values.units)
      values.units = values.units.map(v => ({ unitId: v.unitId || v.value }));
    if (values.channels)
      values.channels = values.channels.map(v => ({
        channelId: v.channelId || v.value,
      }));
    if (values.personalities)
      values.personalities = values.personalities.map(v => ({
        personalityId: v.personalityId || v.value,
      }));
    if (values.personalitiesCredits)
      values.personalitiesCredits = values.personalitiesCredits.map(v => ({
        personalityId: v.personalityId || v.value,
      }));

    // omit unused fields
    const payload = _.omit(
      _.omitBy(
        values,
        (value, key) =>
          _.isNil(value) &&
          !['nextContentSuggestion', 'trailerId', 'launchYear'].includes(key)
      ),
      ['videos', 'relatedContents', 'status']
    );
    const data = {
      createdBy: {
        userId: session.getIdToken().payload.sub,
        name: session.getIdToken().payload.username,
      },
      body: payload,
    };

    return collectionAPI
      .put(`/${id}/versions/${version}`, data)
      .then(resp => {
        resolve(resp);
        if (activeStep === 1) {
          new Promise((resolve, reject) => {
            collectionAPI.put(`/${id}/versions/${version}/videos`, {
              body: {
                videos: videoToCollection.map((video, index) => {
                  video.sortNumber = index + 1;
                  return _.omit(
                    {
                      ...video,
                    },
                    [
                      'title',
                      'version',
                      'thumbnails',
                      'id',
                      'viewsLimit',
                      'totalViews',
                      'status',
                      'expiresIn',
                    ]
                  );
                }),
              },
            });
          });
        }
      })
      .catch(error => {
        setIsLoading(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: `${activeStep ? `Passo ${activeStep}: ` : ''}Erro ao atualizar dados.`,
        });
        console.log(error);
      })
      .then(resp => {
        resolve(resp);
        if (activeStep === 4) {
          new Promise((resolve, reject) => {
            let path = `/${id}/versions/${version}/related-contents`;
            const session = auth;
            const data = {
              createdBy: {
                userId: session.getIdToken().payload.sub,
                name: session.getIdToken().payload.username,
              },
              body: { relatedContents },
            };
            return collectionAPI
              .put(path, data)
              .then(resp => {
                setIsLoading(false);
                resolve(resp);
              })
              .catch(error => {
                setIsLoading(false);
                const errorJson = error.request.response;
                const parseJson = JSON.parse(errorJson);
                setNotify({
                  isOpen: true,
                  message: parseJson.message,
                  type: 'error',
                  title: `${activeStep ? `Passo ${activeStep}: ` : ''}Erro ao atualizar vídeos ou coleções associadas.`,
                });
              });
          });
        }
        setIsLoading(false);
      });
  })
    .catch(error => {
      setIsLoading(false);
      setNotify({
        isOpen: true,
        message: error.message,
        type: 'error',
        title: `${activeStep ? `Passo ${activeStep}: ` : ''}Erro ao atualizar dados.`,
      });
      console.log(error);
    })
    .catch(error => {
      setIsLoading(false);
      const errorJson = error.request.response;
      const parseJson = JSON.parse(errorJson);
      setNotify({
        isOpen: true,
        message: parseJson.message,
        type: 'error',
        title: `${activeStep ? `Passo ${activeStep}: ` : ''}Erro ao atualizar dados.`,
      });
      console.log(error);
    });
};

export const createCollection = async (auth, setAuth, setNotify, title) => {
  return new Promise(resolve => {
    const session = auth;

    const data = {
      createdBy: {
        userId: session.getIdToken().payload.sub,
        name: session.getIdToken().payload.username,
      },

      body: { title },
    };

    return collectionAPI
      .post(data)
      .then(resp => {
        resolve(resp);
      })
      .catch(error => {
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Erro ao criar coleção.',
        });
        //console.log(error);
      });
  });
};

export const getVideoById = async (
  path,
  auth,
  setAuth,
  setNotify,
  setIsLoading = () => {}
) => {
  return new Promise(resolve => {
    setIsLoading(true);
    const session = auth;

    const data = {
      createdBy: {
        userId: session.getIdToken().payload.sub,
        name: session.getIdToken().payload.username,
      },
    };

    return collectionAPI
      .get(path, data)
      .then(resp => {
        resolve(resp);
        setIsLoading(false);
      })
      .catch(error => {
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Erro ao buscar vídeos.',
        });
        //console.log(error);
        setIsLoading(false);
      });
  });
};

export const deleteVideoTrailer = async (
  path,
  setIsLoading,
  setConfirmDialogAction,
  setNotify,
  setTrailerVideoFiles,
  setTrailerDefaultLanguage,
  setSubtitleTrailerFiles,
  setAudioFiles,
  setValue
) => {
  return new Promise(resolve => {
    setIsLoading(true);
    // let path = `/admin/media/${trailerVideoFiles.mediaId}/audio-tracks/${file.trailer.trailerId}`;
    // let path = `/admin/delete-media`;

    return collectionAPI
      .del(path)
      .then(resp => {
        setIsLoading(false);
        setConfirmDialogAction({
          isOpen: false,
        });
        setNotify({
          isOpen: true,
          message: resp.details || resp.message,
          type: 'success',
          title: 'Sucesso!',
        });
        setIsLoading(false);
        setTrailerVideoFiles(null);
        setTrailerDefaultLanguage([]);
        setSubtitleTrailerFiles([]);
        setAudioFiles([]);
        setValue('trailerId', '');
        setValue('trailer_audio_language', '');
        resolve(resp);
      })
      .catch(error => {
        setIsLoading(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Passo 2: Erro ao excluir mídia',
        });
      });
  });
};

export const deleteAudio = async (
  file,
  path,
  setIsLoading,
  setNotify,
  setConfirmDialogAction
) => {
  return new Promise(resolve => {
    setIsLoading(true);
    const data = {
      body: {
        fileIds: [file.audioTrackId],
      },
    };
    return mediaAPI
      .del(path, data)
      .then(resp => {
        setIsLoading(false);
        setConfirmDialogAction({
          isOpen: false,
        });
        resolve(resp);
      })
      .catch(error => {
        console.log('error', error);
        setIsLoading(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Passo 2: Erro ao remover áudio.',
        });
      });
  });
};

export const deleteTrailerSubtitle = (
  trailerId,
  subtitleId,
  setIsLoading,
  setConfirmDialogAction
) => {
  return new Promise(resolve => {
    setIsLoading(true);

    return mediaAPI
      .del(`/${trailerId}/subtitles/${subtitleId}`)
      .then(resp => {
        setIsLoading(false);
        setConfirmDialogAction({
          isOpen: false,
        });
        resolve(resp);
      })
      .catch(error => {
        setIsLoading(false);
        //console.log(error);
      });
  });
};

export const getMediaById = async (path, auth, mediaId, setAuth, setNotify) => {
  return new Promise((resolve, reject) => {
    const session = auth;

    const data = {
      createdBy: {
        userId: session.getIdToken().payload.sub,
        name: session.getIdToken().payload.username,
      },
    };

    return mediaAPI
      .get(path, data)
      .then(resp => {
        resolve(resp);
      })
      .catch(error => {
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Erro ao buscar mídia.',
        });

        //reject(error);
        //console.log(error);
      });
  });
};

// export const process = async (auth, trilerId, setAuth) => {
//   return new Promise((resolve, reject) => {
//     let path = `/admin/contents/${trilerId}/process`;

//     const apiName = 'admin';
//     const session = auth;
//     const idToken = session.getIdToken().getJwtToken();

//     const data = {
//       createdBy: {
//         userId: session.getIdToken().payload.sub,
//         name: session.getIdToken().payload.username,
//       },
//       headers: {
//         Authorization: `${idToken}`,
//       },
//     };

//     return adminAPI
//       .post(
//         path,
//         data
//       )
//       .then(resp => {
//         resolve(resp);
//       })
//       .catch(error => {
//         reject(error);
//         console.log(error);
//       });
//   });
// };

export const getMediaTrailerById = async (
  auth,
  mediaId,
  setTrailerDefaultLanguage,
  setCanAddSubtitleTrailer,
  setTrailerVideoFiles,
  setSubtitleTrailerFiles,
  setTrailerSubtitle,
  setValue,
  setVideoProps,
  setAuth,
  setNotify,
  setAudioFiles,
  setAudioIdioma
) => {
  let path = `/${mediaId}`;
  let response = await getMediaById(path, auth, mediaId, setAuth, setNotify);

  setVideoProps(prevState => ({
    ...prevState,
    trailer: {
      trailerId: mediaId,
      mediaId: mediaId,
      mediaType: response?.extension,
      name: response?.fileName,
    },
  }));
  let filtered = languages.filter(language =>
    language.uuid.includes(response?.audioLanguage)
  );

  setTrailerDefaultLanguage({
    name: filtered[0]?.uuid,
    label: filtered[0]?.name,
  });

  setCanAddSubtitleTrailer(false);
  setTrailerVideoFiles(prevState => ({
    ...prevState,
    trailer: {
      trailerId: mediaId,
      mediaId: mediaId,
      mediaType: response?.extension,
      name: response?.fileName,
    },
  }));
  let subtitles = response?.subtitles;

  if (subtitles?.length > 0) {
    let tempSubs = [];
    for (let sub of subtitles) {
      tempSubs.push({
        name: sub?.language?.fileName,
        label: sub?.language?.name,
        subtitleId: sub?.id,
        accessibility: sub?.accessibility,
      });
    }
    setSubtitleTrailerFiles(tempSubs);
    setTrailerSubtitle(tempSubs);

    let audioTracks = response?.audioTracks;
    if (audioTracks?.length > 0) {
      let tempTracks = [];
      for (let audio of audioTracks) {
        tempTracks.push({
          name: audio?.language?.fileName || audio?.id,
          label: audio?.language?.name,
          audioTrackId: audio?.id,
          accessibility: audio?.accessibility,
        });
      }
      setAudioFiles(tempTracks);
      setAudioIdioma(tempTracks);
    }

    setValue('trailer_audio_language', {
      label: response?.audioLanguage,
      name: response?.audioLanguage,
    });
    // setValue("subtitle_trailer_language", tempSubs);
  }
};

export const publishCollection = async (
  id,
  version,
  auth,
  setIsLoading,
  setViewFields,
  setNotify
) => {
  return new Promise(resolve => {
    setIsLoading(true);
    const path = `/${id}/versions/${version}/status/published`;
    const session = auth;

    const data = {
      createdBy: {
        userId: session.getIdToken().payload.sub,
        name: session.getIdToken().payload.username,
      },
    };

    return collectionAPI
      .patch(path, data)
      .then(resp => {
        setIsLoading(false);
        setViewFields(true);
        resolve(resp);
      })
      .catch(error => {
        setIsLoading(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Erro ao publicar.',
        });
        //console.log(error);
      });
  });
};

export const getRelatedContents = async (
  id,
  version,
  auth,
  setIsLoading,
  setAuth,
  setNotify
) => {
  return new Promise(resolve => {
    setIsLoading(true);

    const path = `/${id}/versions/${version}/related`; ///admin/contents/${id}/versions/${version}

    const session = auth;

    const data = {
      createdBy: {
        userId: session.getIdToken().payload.sub,
        name: session.getIdToken().payload.username,
      },
    };

    return collectionAPI
      .get(path, data)
      .then(resp => {
        setIsLoading(false);
        resolve(resp);
      })
      .catch(error => {
        setIsLoading(false);
        setNotify({
          isOpen: true,
          message: error.message,
          type: 'error',
          title: 'Passo 4: Erro ao buscar vídeos e coleções associadas.',
        });
        console.log(error);
      });
  });
};

export const getRelatedFromCollection = async (
  path,
  auth,
  setAuth,
  setNotify
) => {
  return new Promise(resolve => {
    const session = auth;

    const data = {
      createdBy: {
        userId: session.getIdToken().payload.sub,
        name: session.getIdToken().payload.username,
      },
    };

    return adminAPI
      .get(path, data)
      .then(resp => {
        resolve(resp);
      })
      .catch(error => {
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Passo 4: Erro ao buscar vídeos e coleções associadas.',
        });
        //console.log(error);
      });
  });
};
